import React from 'react'
import clsx from 'clsx'
import Image from 'next/legacy/image'
import Map, { Marker, NavigationControl } from 'react-map-gl'

import 'mapbox-gl/dist/mapbox-gl.css'
import MarkerIcon from './mapbox-marker.svg'

export interface MapboxProps {
  lat?: number
  long?: number
  zoom?: number
  height?: string
  className?: string
}

const MAPBOX_TOKEN =
  'pk.eyJ1IjoiY2xvb3BpbyIsImEiOiJjbDUwd3lyamowMDNvM2NxcXlsa2E1MTIzIn0._krnzQoOaRqwQX7-8h1kzw'

const Mapbox = ({
  lat = 40.392976212547836,
  long = -72.61060878427122,
  zoom = 8,
  height = 'h-80',
  className = undefined,
}: MapboxProps) => {
  const [viewState, setViewState] = React.useState({
    latitude: lat,
    longitude: long,
    zoom,
  })

  return (
    <div className={clsx(height, className, 'w-full overflow-hidden rounded-lg')}>
      <Map
        reuseMaps
        {...viewState}
        onMove={(evt) => setViewState(evt.viewState)}
        style={{ width: '100%', height: '100%' }}
        mapStyle="mapbox://styles/cloopio/cl50xjx10006w14llp2p8ptay"
        mapboxAccessToken={MAPBOX_TOKEN}
      >
        <Marker longitude={long} latitude={lat}>
          <Image src={MarkerIcon} alt="Cloopio" width={54} height={60} />
        </Marker>

        <NavigationControl position="bottom-right" />
      </Map>
    </div>
  )
}

export default Mapbox
